import { create } from 'zustand';
import { Auth, type AuthStatus } from '../api/client';

type Toast = { id: number; kind: 'info' | 'success' | 'error'; message: string };

type Store = {
  auth: AuthStatus | null;
  setAuth: (a: AuthStatus) => void;
  refreshAuth: () => Promise<void>;

  toasts: Toast[];
  pushToast: (t: Omit<Toast, 'id'>) => void;
  dismissToast: (id: number) => void;
};

let toastId = 0;

export const useStore = create<Store>((set, get) => ({
  auth: null,
  setAuth: (a) => set({ auth: a }),
  refreshAuth: async () => {
    try {
      const a = await Auth.status();
      set({ auth: a });
    } catch (e) {
      console.warn('auth status failed', e);
    }
  },

  toasts: [],
  pushToast: (t) => {
    const id = ++toastId;
    set({ toasts: [...get().toasts, { ...t, id }] });
    setTimeout(() => {
      set({ toasts: get().toasts.filter((x) => x.id !== id) });
    }, 4000);
  },
  dismissToast: (id) => set({ toasts: get().toasts.filter((x) => x.id !== id) }),
}));
